import { Component, isDevMode, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { SnackBarService } from "src/app/shared";
import { SharedCustomersService } from "src/app/shared/services/customers/customers.service";
import { NotificationService } from "../../services/notification.service";
import { LocationService } from "src/app/shared/services/location/location.service";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ResolverService } from "src/app/core";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MyUploadAdapter } from "./my-upload-adaptor";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import * as data from "./data.json";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-create-event",
  templateUrl: "./create-event.component.html",
  styleUrls: ["./create-event.component.scss"],
})
export class CreateEventComponent implements OnInit {
  eventId: any;
  createEventForm: FormGroup;
  eventDetail: any;
  smtpProviderList: any;
  groupList: any;
  templateList: any;
  files: any[] = [];
  duplicated: boolean = false;

  filterForm: FormGroup;
  countries: any[];
  selectedCustomers: any[] = new Array<any>();
  lastFilter: string = "";
  filteredCustomers: Observable<any[]>;
  availableCustomers: any[];
  showReciepients: boolean = false;
  notification_group: FormControl = new FormControl("");
  notification_group_default: FormControl = new FormControl("");
  notification_contact_groups: FormControl = new FormControl("");
  template_field: FormControl = new FormControl("");
  officesList: any;
  customerList: any;
  customersDisplayedColumns = ["checkbox", "name", "customerCode"];
  panelOpenState: boolean = false;
  prefillData: any;
  contactGroupsList: any;

  public editor = Editor;
  public config = {
    placeholder: "Content",
    htmlSupport: {
      allow: [
        {
          name: /.*/,
          attributes: true,
          classes: true,
          styles: true,
        },
      ],
    },
  };
  templates = JSON.parse(JSON.stringify(data));

  constructor(
    private notificationService: NotificationService,
    private snackbarService: SnackBarService,
    private router: Router,
    private sharedCustomersService: SharedCustomersService,
    private http: HttpClient,
    private storageService: LocalStorageService
  ) {
    this.prefillData = this.router.getCurrentNavigation().extras.state;
  }

  onReady(editor: ClassicEditor): void {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return new MyUploadAdapter(loader, this.storageService.accessToken);
    };
  }

  ngOnInit() {
    this.initForms();
    this.getSmtpProviderList();
    this.getGroupList();
    this.getContactGroupsList();
    this.getTemplateList();
    this.getCustomersList();
    this.getCountryLists();
    // this.getOfficesList();
  }

  initForms() {
    this.createEventForm = new FormGroup({
      title: new FormControl("", Validators.required),
      smtp_provider: new FormControl(""),
      type: new FormControl(1),
      template: new FormControl(""),
      subject: new FormControl("", Validators.required),
      content: new FormControl(""),
    });

    this.filterForm = new FormGroup({
      city__state__country: new FormControl(""),
      search: new FormControl(""),
      office: new FormControl(""),
    });

    if (this.prefillData) {
      this.createEventForm.patchValue({
        title: this.prefillData.title,
        type: this.prefillData.notification_event_type,
        subject: this.prefillData.subject,
        content: this.prefillData.content,
      });

      if (this.prefillData.smtp_provider_detail) {
        this.createEventForm.patchValue({
          smtp_provider: this.prefillData.smtp_provider_detail["id"],
        });
      }

      if (this.prefillData.template_detail) {
        this.createEventForm.patchValue({
          template: this.prefillData.template_detail["id"],
        });
      }
      this.notification_group.patchValue(
        this.prefillData.notification_groups_detail.map((group) => group.id)
      );
    }
    this.template_field.valueChanges.subscribe((val) => {
      if (val) {
        this.createEventForm
          .get("content")
          .patchValue(
            val.content.replace(/{{panel_base_url}}/g, environment.projectUrl)
          );
      }
    });
  }

  getCountryLists() {
    this.sharedCustomersService.getAdminCountrySummary().subscribe(
      (data) => {
        this.countries = data;
      },
      (error) => {}
    );
  }

  getOfficesList() {
    this.notificationService
      .getOfficesList({ limit: 1000 })
      .subscribe((data) => {
        this.officesList = data.results;
      });
  }

  onSubmitFilterForm() {
    this.getCustomersList();
  }

  getCustomersList(search: string = "") {
    if (typeof search == "string") {
      const filters = {
        user_active: true
      }
      this.sharedCustomersService
        .getAllCustomers(filters)
        .subscribe((success) => {
          this.customerList = success;
        });
    }
  }

  filter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.availableCustomers.filter((option) => {
        return option.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      return this.availableCustomers.slice();
    }
  }

  displayFn(value: any[] | string): string | undefined {
    let displayValue: string;
    if (Array.isArray(value)) {
      value.forEach((customer, index) => {
        if (index === 0) {
          displayValue = customer.name;
        } else {
          displayValue += ", " + customer.name;
        }
      });
    } else {
      displayValue = value;
    }
    return displayValue;
  }

  optionClicked(event: Event, customer: any) {
    event.stopPropagation();
    this.toggleSelection(customer);
  }

  toggleSelection(customer: any) {
    customer.selected = !customer.selected;
  }

  getSmtpProviderList() {
    this.notificationService.getSmtpProviderList().subscribe((res) => {
      this.smtpProviderList = res.results;
      if (this.smtpProviderList.length) {
        this.createEventForm.patchValue({
          smtp_provider: this.smtpProviderList[0].id,
        });
      } else {
        this.createEventForm.get("type").patchValue(1);
      }
    });
  }

  getGroupList() {
    this.notificationService.getNotificationGroupsList({}).subscribe((res) => {
      this.groupList = res.results;
    });
  }

  getContactGroupsList() {
    this.notificationService
      .getNotificationContactsGroupsList({})
      .subscribe((res) => {
        this.contactGroupsList = res.results;
      });
  }

  getTemplateList() {
    this.notificationService.getEmailTemplatesList({}).subscribe((res) => {
      this.templateList = res.results;
    });
  }

  createEvent() {
    let recipients = [];
    let notification_groups = [];
    let notification_contact_groups = [];

    if (
      this.notification_group.value ||
      this.notification_group_default.value ||
      this.notification_contact_groups.value
    ) {
      for (let group of [
        ...this.notification_group.value,
        ...this.notification_group_default.value,
        ...this.notification_contact_groups.value,
      ]) {
        let [group_type, id] = group.split("-");
        switch (group_type) {
          case "g": // Group
            notification_groups.push(id);
            break;

          case "cg": //Contact Group
            notification_contact_groups.push(Number(id));
            break;

          case "d": //Default
            switch (id) {
              case "0": // All
                for (let customer of this.customerList) {
                  recipients.push(customer.user);
                }
                break;
            }
            break;

          case "c": // Country
            let country_customers = this.countries.find(
              (country) => country.country_detail.id == id
            ).user_ids;
            for (let customer of country_customers) {
              recipients.push(customer);
            }
            break;
        }
      }
      // this.notification_group.value.forEach(element => {
      //   formData.append('notification_groups',element)
      // });
    }

    let formData;
    if (this.files.length !== 0) {
      formData = new FormData();
      Object.entries(this.createEventForm.value).forEach(
        ([key, value]: any[]) => {
          if (value) {
            formData.set(key, value);
          }
        }
      );
      let i = 0;
      for (let file of this.files) {
        formData.set(`attachments[${i}]file`, file);
        i++;
      }
      if (recipients) {
        recipients.forEach((el) => {
          formData.append("recipients", el);
        });
      }
      if (notification_groups) {
        notification_groups.forEach((el) => {
          formData.append("notification_groups", el);
        });
      }
      if (notification_contact_groups) {
        notification_contact_groups.forEach((el) => {
          formData.append("contact_groups", el);
        });
      }
    } else {
      formData = {
        title: this.createEventForm.controls.title.value
          ? this.createEventForm.controls.title.value
          : "",
        smtp_provider: this.createEventForm.controls.smtp_provider.value
          ? this.createEventForm.controls.smtp_provider.value
          : "",
        subject: this.createEventForm.controls.subject.value
          ? this.createEventForm.controls.subject.value
          : "",
        content: this.createEventForm.controls.content.value
          ? this.createEventForm.controls.content.value
          : "",
        template: this.createEventForm.controls.template.value
          ? this.createEventForm.controls.template.value
          : "",
      };
      if (recipients) {
        formData = {
          ...formData,
          recipients,
        };
      }
      if (this.notification_group.value) {
        formData["notification_groups"] = notification_groups;
      }
      if (this.notification_contact_groups.value) {
        formData["contact_groups"] = notification_contact_groups;
      }
    }
    this.notificationService.createNotificationEvent(formData).subscribe(
      (success) => {
        this.snackbarService.showSnack("Campaign Created Successfuly.");
        this.router.navigate([`/notifications/events`], {
          queryParams: { event: success.id },
        });
      },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  openFileField() {
    document.getElementById("file").click();
  }

  onUpload(event: any) {
    this.duplicated = false;
    if (!event.target.files.length) {
      return;
    }
    let file = event.target.files[0];
    this.files.forEach((item) => {
      if (item.name === file.name) {
        this.duplicated = true;
      }
    });
    if (!this.duplicated) {
      this.files.push(file);
    }
  }

  removeFile(index) {
    this.files.splice(index, 1);
  }

  isCustomerSelected(id) {
    return this.selectedCustomers.indexOf(id) != -1;
  }
}
